// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "errorWrapper-GTwFG";
var _3 = "errorTitle-wdXWC";
var _4 = "errorText-3zT80";
export { _1 as "__esModule", _2 as "errorWrapper", _3 as "errorTitle", _4 as "errorText" }
export default { "__esModule": _1, "errorWrapper": _2, "errorTitle": _3, "errorText": _4 }
